import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@rtkwlf/pro-solid-svg-icons/faClose';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useActionDrawer } from '@packages/components/action-drawer/action-drawer-context';
import { Box, Button, Stack, Typography } from '@packages/fenrir/components';

type Props = {
  rowsSelected: number;
};
export const FormHeaderAllRisks: React.FC<Props> = ({ rowsSelected }) => {
  const { t } = useTranslation('riskManagement', { keyPrefix: 'risks' });
  const { t: tUi } = useTranslation('ui');

  const { reset } = useFormContext<FormData>();
  const { closeDrawer } = useActionDrawer();

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={4}
      >
        <Typography variant="h3">{t('actionDrawerTitle')}</Typography>
        <Button
          startIcon={<FontAwesomeIcon icon={faClose} aria-label="rotate" />}
          onClick={() => {
            reset();
            closeDrawer();
          }}
        >
          {tUi('close')}
        </Button>
      </Stack>

      <Typography>
        {t('risksSelected', {
          count: rowsSelected,
        })}
      </Typography>

      <Typography my={2}>{t('overwriteMessage')}</Typography>
    </Box>
  );
};
